import type { PlanogramPegboard } from "@CommonTypes/merchflow/pog/pegboard";

/** Returns the absolute horizontal anchor used by a pegboard and its holes. */
export const getPegboardXLeft = (pegboard: PlanogramPegboard) =>
  pegboard.sectionX ?? pegboard.bay.getXLeft();
